"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var button_styles_1 = require("./button.styles");
var analyticsService_1 = require("../../analytics/analyticsService");
exports.Button = function (props) {
    var className = button_styles_1.button;
    if (props.small) {
        className = className + " " + button_styles_1.smallButton;
    }
    if (props.text || props.icon) {
        className = className + " " + button_styles_1.textButton;
    }
    if (props.rounded) {
        className = className + " " + button_styles_1.roundedButton;
    }
    if (props.className) {
        className = className + " " + props.className;
    }
    if (props.neutral) {
        className = className + " " + button_styles_1.neutralButton;
    }
    var content = props.icon ? (React.createElement("div", { className: button_styles_1.iconContainer }, props.children)) : (props.children);
    var active = props.active ? { "data-qa-active": true } : undefined;
    var display = props.qa ? { "data-qa": props.qa } : undefined;
    function performOnClick() {
        analyticsService_1.AnalyticsService.recordEvent(props.id);
        if (props.onClick) {
            props.onClick();
        }
    }
    return (React.createElement("button", __assign({ className: className, id: "" + props.id, onClick: performOnClick, disabled: props.disabled, type: props.type }, active, display), content));
};
